import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../../lib/api';

export default function useRestauranteCocina() {
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [accionando, setAccionando] = useState(null);

  const mounted = useRef(true);

  const cargar = useCallback(async () => {
    try {
      const response = await api.get('/restaurante/pedidos/cocina');

      if (!mounted.current) return;

      setPedidos(Array.isArray(response.data) ? response.data : []);
      setError('');
    } catch (err) {
      if (!mounted.current) return;

      setError(
        err?.response?.data?.error ||
        'No se pudo cargar el tablero de cocina.'
      );
    } finally {
      if (mounted.current) {
        setCargando(false);
      }
    }
  }, []);

  const ejecutar = useCallback(async (pedidoId, accion, usuarioId) => {
    setAccionando(`${pedidoId}:${accion}`);

    try {
      const rutas = {
        iniciar: `/restaurante/pedidos/${pedidoId}/iniciar-preparacion`,
        listo: `/restaurante/pedidos/${pedidoId}/listo`,
        entregar: `/restaurante/pedidos/${pedidoId}/entregado`,
      };

      await api.post(rutas[accion], {
        usuario_id: usuarioId,
      });

      await cargar();

      return { ok: true };
    } catch (err) {
      const mensaje =
        err?.response?.data?.error ||
        'No se pudo actualizar el pedido.';

      setError(mensaje);

      return {
        ok: false,
        error: mensaje,
      };
    } finally {
      setAccionando(null);
    }
  }, [cargar]);

  useEffect(() => {
    mounted.current = true;

    cargar();

    const interval = setInterval(cargar, 5000);

    return () => {
      mounted.current = false;
      clearInterval(interval);
    };
  }, [cargar]);

  return {
    pedidos,
    cargando,
    error,
    accionando,
    recargar: cargar,
    iniciarPreparacion: (id, usuarioId) =>
      ejecutar(id, 'iniciar', usuarioId),
    marcarListo: (id, usuarioId) =>
      ejecutar(id, 'listo', usuarioId),
    marcarEntregado: (id, usuarioId) =>
      ejecutar(id, 'entregar', usuarioId),
  };
}
